import React from 'react';
import {Button, Menu, MenuItem, Position} from '@blueprintjs/core';
import {Popover2} from '@blueprintjs/popover2';
import {IconNames} from '@blueprintjs/icons';

interface NavigationMenuProps {
  showAdministrationMenu: boolean;
  onSearch: () => void;
}

const MenuContent = ({
  showAdministrationMenu,
  onSearch
}: any) => {
  return (
    <Menu>
      <MenuItem
        onClick={onSearch}
        text="Search"
        icon={IconNames.SEARCH}
      />
      <MenuItem href="/app" text="Home" icon={IconNames.HOME}/>
      <MenuItem href="/r" text="Explore" icon={IconNames.GEOLOCATION}/>
      <MenuItem href="/d" text="Data & Integrations" icon={IconNames.DATA_CONNECTION}/>
      <MenuItem href="/a/log" text="Execution Log" icon={IconNames.PULSE}/>
      {showAdministrationMenu && <MenuItem href="/a/o" text="Administration" icon={IconNames.COG}/>}
    </Menu>
  )
}

export const NavigationMenu = ({
  showAdministrationMenu,
  onSearch,
}: NavigationMenuProps) => {
  return (
    <Popover2
      position={Position.BOTTOM_LEFT}
      content={<MenuContent showAdministrationMenu={showAdministrationMenu} onSearch={onSearch}/>}
    >
      <Button
        large={false}
        minimal={true}
        outlined={true}
        icon={IconNames.MENU}
      />
    </Popover2>
  )
}

export default NavigationMenu;
